// Web Sentry facade. The native build swaps in @sentry/react-native (see
// sentry.native.ts). On web this is a transparent re-export of @sentry/react.
export * from "@sentry/react";
